<template>
  <my-view :GetCollCategoryList="GetCollCategoryList" :GetfollowGoodsList="GetfollowGoodsList" :AddShopCart="AddShopCart" :DelCollection="DelCollection" :BatchAddShopCart="BatchAddShopCart"></my-view>
</template>

<script>
import {
  AddShopCart,
  DelCollection,
  BatchAddShopCart,
  GetCollCategoryList,
  GetfollowGoodsList,
} from "@/pages/page1/api/modules/shoppingCart";

import MyView from "@/pages/publicView/personalCenter/followGoods_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetCollCategoryList,
      GetfollowGoodsList,
      AddShopCart,
      DelCollection,
      BatchAddShopCart,
    };
  },
};
</script>